import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import React, { useState } from "react";
import { IconsRenderer } from "../../assets/icon-pack";
import { AnimatePresence, motion } from "framer-motion";
import "./search.scss";
import { INPUT_LIMITS } from "../input-limits";

function Search({
  value,
  onChange,
  className,
  placeholder = "Search",
  placeholderAlign,
  minLength,
  maxLength,
  ...props
}) {
  var containerClasses = classNames(
    "grigora-search-ui-kit-component w-full text-grigora-base shadow-main h-10 px-4 bg-white rounded-full grigora-search-bar flex items-center gap-0",
    {
      ["placeholder-" + placeholderAlign]: placeholderAlign,
    },
    className,
  );

  // Remove icon while input is focused
  var [isFocused, setIsFocused] = useState(false);

  return (
    <div {...props} className={containerClasses}>
      {/* Todo change search icon */}
      {/* <IconsRenderer name="Search" /> */}
      <AnimatePresence>
        {isFocused ? null : (
          <motion.span
            variants={{
              open: { opacity: 1, width: "auto", overflow: "unset" },
              collapsed: {
                opacity: 0,
                width: 0,
                overflow: "hidden",
              },
            }}
            key="input-search-icon"
            initial="collapsed"
            animate="open"
            exit="collapsed"
          >
            <FontAwesomeIcon icon={faSearch} />
          </motion.span>
        )}
      </AnimatePresence>
      <input
        type="text"
        className="w-full h-full ml-3 pl-[5px] outline-none rounded-full search-field"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={(e) => {
          setIsFocused(false);
        }}
        onFocus={(e) => {
          setIsFocused(true);
        }}
        minLength={
          minLength ? minLength : INPUT_LIMITS["search-input"].minlength
        }
        maxLength={
          minLength ? minLength : INPUT_LIMITS["search-input"].maxlength
        }
      />
    </div>
  );
}

export default Search;
